import { THttpService } from '@/services/HttpService';

import { getValue } from '@/helpers/GetValueHelper';

import { TContentObj, TModalContent, TResponseContent } from './types';

export const formatSuccess = async (
  data: TResponseContent,
): Promise<TModalContent[]> => {
  const base = (indexModal: number, index: number) =>
    `items[${indexModal}].contentFields[${index}]`;

  const getContentFieldIndex = (
    name: string,
    contentFieldData: TResponseContent,
    indexModal: number,
  ) => {
    return contentFieldData.items[indexModal].contentFields.findIndex(cf => {
      return cf.nestedContentFields.some(
        ncf => ncf.name === 'name' && ncf.contentFieldValue.data === name,
      );
    });
  };

  const getAtributeContentObj = (attributeName: string, indexModal: number) => {
    return {
      text: getValue(
        data,
        `${base(
          indexModal,
          getContentFieldIndex(attributeName, data, indexModal),
        )}.nestedContentFields[2].contentFieldValue.data`,
      ) as string,
      icon: getValue(
        data,
        `${base(
          indexModal,
          getContentFieldIndex(attributeName, data, indexModal),
        )}.nestedContentFields[1].nestedContentFields[0].contentFieldValue.document.contentUrl`,
      ) as string,
    } as TContentObj;
  };

  const resultArray: TModalContent[] = data.items.map((item, indexModal) => ({
    title: getAtributeContentObj('title', indexModal),
    badge: getAtributeContentObj('badge', indexModal),
    milesLabel: getAtributeContentObj('miles_label', indexModal),
    changeLink: getAtributeContentObj('change_link', indexModal),
    minLabel: getAtributeContentObj('min_label', indexModal),
    maxLabel: getAtributeContentObj('max_label', indexModal),
    totalLabel: getAtributeContentObj('total_label', indexModal),
    paymentMethodText: getAtributeContentObj('payment_method_text', indexModal),
    chooseVoucherLink: getAtributeContentObj('choose_voucher_link', indexModal),
    ruleBtn: getAtributeContentObj('rule_btn', indexModal),
    continueBtn: getAtributeContentObj('continue_btn', indexModal),
    quantityLabel: getAtributeContentObj('quantity_label', indexModal),
    codeLabel: getAtributeContentObj('code_label', indexModal),
    validityLabel: getAtributeContentObj('validity_label', indexModal),
    milesValueLabel: getAtributeContentObj('miles_value_label', indexModal),
    installmentLabel: getAtributeContentObj('installment_label', indexModal),
    maxMilesLabel: getAtributeContentObj('max_miles_label', indexModal),
    minMilesLabel: getAtributeContentObj('min_miles_label', indexModal),
    reusableLabel: getAtributeContentObj('reusable_label', indexModal),
    availabilityLabel: getAtributeContentObj('availability_label', indexModal),
    validityValue: getAtributeContentObj('validity_value', indexModal),
    milesValue: getAtributeContentObj('miles_value', indexModal),
    installmentValue: getAtributeContentObj('installment_value', indexModal),
    yesLabel: getAtributeContentObj('yes_label', indexModal),
    noLabel: getAtributeContentObj('no_label', indexModal),
    availabilityValue: getAtributeContentObj('availability_value', indexModal),
    description: getAtributeContentObj('description', indexModal),
    voucherTitle: getAtributeContentObj('voucher_title', indexModal),
    voucherIcon: getAtributeContentObj('voucher_icon', indexModal),
    ofLabel: getAtributeContentObj('of_label', indexModal),
    voucherValidity: getAtributeContentObj('voucher_validity', indexModal),
    voucherUseBtn: getAtributeContentObj('voucher_use_btn', indexModal),
    buyingLabel: getAtributeContentObj('buying_label', indexModal),
    voucherLimitLabel: getAtributeContentObj('voucher_limit_label', indexModal),
    discountPercLabel: getAtributeContentObj('discount_perc_label', indexModal),
    milesTotalLabel: getAtributeContentObj('miles_total_label', indexModal),
    discountLabel: getAtributeContentObj('discount_label', indexModal),
    buyBtn: getAtributeContentObj('buy_btn', indexModal),
    tryAgainBtn: getAtributeContentObj('try_again_btn', indexModal),
    tripTypeLabel: getAtributeContentObj('trip_type_label', indexModal),
    classTypeLabel: getAtributeContentObj('class_type_label', indexModal),
    termOfUseLabel: getAtributeContentObj('term_of_use_label', indexModal),
    odLabel: getAtributeContentObj('od_label', indexModal),
    untilLabel: getAtributeContentObj('until_label', indexModal),
    oneWayLabel: getAtributeContentObj('oneway_label', indexModal),
    roundtripLabel: getAtributeContentObj('roundtrip_label', indexModal),
    businessLabel: getAtributeContentObj('business_label', indexModal),
    comfortLabel: getAtributeContentObj('comfort_label', indexModal),
    milesPurchaseVoucher: getAtributeContentObj(
      'miles_purchase_voucher',
      indexModal,
    ),
    milesPurchaseVoucherLink: getAtributeContentObj(
      'miles_purchase_voucher_link',
      indexModal,
    ),
    airlineVoucher: getAtributeContentObj('airline_voucher', indexModal),
    airlineVoucherLink: getAtributeContentObj(
      'airline_voucher_link',
      indexModal,
    ),
    reusableYesValue: getAtributeContentObj('reusable_yes_value', indexModal),
    reusableNoValue: getAtributeContentObj('reusable_no_value', indexModal),
    partnerCompanyNameLabel: getAtributeContentObj(
      'partner_company_name_label',
      indexModal,
    ),
    paymentTypeLabel: getAtributeContentObj('payment_type_label', indexModal),
    productTypeLabel: getAtributeContentObj('product_type_label', indexModal),
    availableMilesLabel: getAtributeContentObj(
      'available_miles_label',
      indexModal,
    ),
    availableValueLabel: getAtributeContentObj(
      'available_value_label',
      indexModal,
    ),
    allTripLabel: getAtributeContentObj('all_trip_label', indexModal),
    allClassTypeLabel: getAtributeContentObj(
      'all_class_type_label',
      indexModal,
    ),
    allProductTypeLabel: getAtributeContentObj(
      'all_product_type_label',
      indexModal,
    ),
    discountMilesLabel: getAtributeContentObj(
      'discount_miles_label',
      indexModal,
    ),
    discountMoneyLabel: getAtributeContentObj(
      'discount_money_label',
      indexModal,
    ),
    discountPercentageMoneyLabel: getAtributeContentObj(
      'discount_percentage_money_label',
      indexModal,
    ),

    id: item.friendlyUrlPath,
  }));
  return resultArray;
};

export const formatError = () => {
  return [] as TModalContent[];
};

export const getModalContent = async (
  api: THttpService,
  keyArr: string[],
): Promise<TModalContent[]> => {
  const query = encodeURI(
    `filter=(${keyArr.map(key => `title eq '${key}'`).join(' or ')})`,
  );
  const path =
    '/o/headless-delivery/v1.0/sites/20124/structured-contents?flatten=true&';

  let data = {};
  try {
    const response = await api.get(path + query);
    data = response.data;
    return await formatSuccess(data as TResponseContent);
  } catch (error) {
    return formatError();
  }
};
